import React from 'react';
import { useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { slugs } from '../Constant/slugs';
import '../styles.css'
import { MainUrl, sideBarImage } from '../Constant/api';
import Database from '../Constant/database.json'

const SideBarBlock = ({
  allSlug, newSlug, location,
  Title, icon, setExpand, Expand,
  setMenuExpand
}) => {
  return (
    <div>
      <div className={location.pathname == allSlug ? "row active-sidebar" : "row passive-sidebar"}>
        <Link className={"Link col-10"} to={allSlug}>
          <div className={location.pathname == allSlug ? "active-sidebar-font" : "passive-sidebar-font"}
            onClick={() => {
              setMenuExpand(false)
            }}
          >
            &nbsp; &nbsp;{Title}
          </div>
        </Link>
        {newSlug !== "" &&
          <div className="col-1" style={{ cursor: 'pointer' }}
            onClick={() => {
              setExpand(!Expand)
            }}>
            <i className={Expand ? "fa fa-minus" : "fa fa-plus"} style={{ fontSize: "10px" }} />
          </div>
        }
      </div>
      {Expand && newSlug !== "" &&
        <>
          <Link className={location.pathname == allSlug ? "Link active-sidebar" : "Link passive-sidebar"}
            style={{ paddingLeft: "40px" }}
            to={allSlug}
          >
            <div className={location.pathname == allSlug ? "Link active-sidebar-font" : "Link passive-sidebar-font"}>
              All {Title}
            </div>
          </Link>
          <Link className={location.pathname == `/${newSlug}` ? "Link active-sidebar" : "Link passive-sidebar"}
            style={{ paddingLeft: "40px" }}
            to={newSlug}
          >
            <div className={location.pathname == `/newSlug` ? "active-sidebar-font" : "passive-sidebar-font"}>
              Add New {Title.slice(0, -1)}
            </div>
          </Link>
        </>
      }
    </div>
  )
}
export default function SideBar({ setMenuExpand }) {
  const LoginUser = useSelector((state) => state.LoginState);
  const [Menu, setMenu] = React.useState(false)
  const location = useLocation()

  const [BatchExpand, setBatchExpand] = React.useState(false)
  const [StudentsExpand, setStudentExpand] = React.useState(false)
  const [TeacherExpand, setTeacherExpand] = React.useState(false)
  const [StaffExpand, setStaffExpand] = React.useState(false)
  const [IncomeExpand, setIncomeExpand] = React.useState(false)
  const [InvoicesExpand, setInvoicesExpand] = React.useState(false)
  const [ExpensesExpand, setExpensesExpand] = React.useState(false)

  return (
    <div>
      <div className="small-display-none">
        <div style={{ justifyContent: 'center', display: 'flex', padding: "30px", borderBottom: "1px solid #eee" }}>
          <img
            src={sideBarImage}
            style={{ width: "200px", height: "100px", objectFit: 'contain' }}
          />
        </div>
      </div>

      <div className="small-display-block">
        <div className="row passive-sidebar" onClick={() => { setMenuExpand(false) }}>
          <div className={"passive-sidebar-font"}>
            <i className="fa fa-close" style={{ fontSize: "16px" }} />&nbsp; &nbsp;Close
          </div>
        </div>
      </div>
      {/* Home */}
      {/* {LoginUser.userRole} */}
      {(LoginUser.userRole == "author") &&
        <>
          {/* <SideBarBlock
            allSlug={"/"} newSlug={""}
            location={location} Title={"Dashboard"}
            icon={""}
          /> */}
          <SideBarBlock
            allSlug={`${slugs.all_batches}`} newSlug={`${slugs.new_batch}`}
            location={location} Title={"Batch"}
            icon={""}
            Expand={BatchExpand}
            setExpand={setBatchExpand}
          />
          <SideBarBlock
            allSlug={`${slugs.all_students}`} newSlug={`${slugs.new_students}`}
            location={location} Title={"Students"}
            icon={""}
            Expand={StudentsExpand}
            setExpand={setStudentExpand}
          />
          <SideBarBlock
            allSlug={`${slugs.all_teachers}`} newSlug={`${slugs.new_teachers}`}
            location={location} Title={"Teachers"}
            icon={""}
            Expand={TeacherExpand}
            setExpand={setTeacherExpand}
          />
          <SideBarBlock
            allSlug={`${slugs.all_employee}`} newSlug={`${slugs.new_employee}`}
            location={location} Title={"Staff"}
            icon={""}
            Expand={StaffExpand}
            setExpand={setStaffExpand}
          />
          <SideBarBlock
            allSlug={`${slugs.all_payments_received}`} newSlug={`${slugs.new_payments_received}`}
            location={location} Title={"Income"}
            icon={""}
            Expand={IncomeExpand}
            setExpand={setIncomeExpand}
          />
          <SideBarBlock
            allSlug={`${slugs.all_invoices}`} newSlug={`${slugs.new_invoices}`}
            location={location} Title={"Invoices"}
            icon={""}
            Expand={IncomeExpand}
            setExpand={setIncomeExpand}
          />
          <SideBarBlock
            allSlug={`${slugs.all_expenses}`} newSlug={`${slugs.new_expenses}`}
            location={location} Title={"Expenses"}
            icon={""}
            Expand={ExpensesExpand}
            setExpand={setExpensesExpand}
          />
        </>
      }

      {(LoginUser.userRole == "subscriber") &&
        <>
          <>
            <SideBarBlock
              allSlug={`${slugs.all_students}`} newSlug={`${slugs.new_students}`}
              location={location} Title={"Students"}
              icon={""}
              Expand={StudentsExpand}
              setExpand={setStudentExpand}
            />
            <SideBarBlock
              allSlug={`${slugs.all_teachers}`} newSlug={``}
              location={location} Title={"Teachers"}
              icon={""}
              Expand={TeacherExpand}
              setExpand={setTeacherExpand}
            />
            <SideBarBlock
              allSlug={`${slugs.all_payments_received}`} newSlug={`${slugs.new_payments_received}`}
              location={location} Title={"Income"}
              icon={""}
              Expand={IncomeExpand}
              setExpand={setIncomeExpand}
            />
            <SideBarBlock
              allSlug={`${slugs.all_invoices}`} newSlug={`${slugs.new_invoices}`}
              location={location} Title={"Invoices"}
              icon={""}
              Expand={IncomeExpand}
              setExpand={setIncomeExpand}
            />
             <SideBarBlock
              allSlug={`/topics`} newSlug={``}
              location={location} Title={"Topics"}
              icon={""}
              Expand={IncomeExpand}
              setExpand={setIncomeExpand}
            />
          </>
        </>
      }
      {/* <SideBarBlock
        allSlug={"/profile"} newSlug={""}
        location={location} Title={"Profile"}
        icon={""}
        setExpand={setBookExpand} Expand={BookExpand}
        setMenuExpand={setMenuExpand}
      /> */}
    </div>
  )
}